/* React */
import React from "react";

/* Ionic */
import {
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
} from "@ionic/react";

/* Stylesheet */
import styles from "./DataImportWrapper.module.scss";

/* Interfaces */
interface DataImportWrapperProps {
  children: React.ReactNode[];
}

const DataImportWrapper: React.FC<
  DataImportWrapperProps
> = ({ children }) => {
  return (
    <IonGrid className={styles.data_import_wrapper}>
      <IonRow className={styles.row}>
        <IonCol className={`${styles.col}`}>
          <IonCard className={styles.children_container}>
            {children[0]}
          </IonCard>
        </IonCol>
        <IonCol className={`${styles.col}`}>
          <IonCard className={styles.children_container}>
            {children[1]}
          </IonCard>
        </IonCol>
      </IonRow>
    </IonGrid>
  );
};

export default DataImportWrapper;
